import { createI18n } from 'vue-i18n';
import zhCNEx from './locale/zh-CN.json';
import enUSEx from './locale/en-US.json';
import { Lang, getLocalLang } from '@/i18n/utils';

type EnUSType = typeof enUSEx;

const messages = {
  'en-US': enUSEx,
  'zh-CN': zhCNEx,
};

export const i18n = createI18n<[EnUSType], Lang>({
  legacy: false,
  // 仅运行一次，非受控
  locale: getLocalLang(),
  fallbackLocale: 'en-US',
  messages,
});
